export const laundryDuration = 1.5
export const firstAvailableLaundryStartTime = 7
export const lastAvailableLaundryEndTime = 22
export const daysAheadLaundry = 14
export const maximumNumberOfLaundryBookings = 2

export const firstAvailableBalconyStartTime = 10
export const balconyDuration = 6
export const daysAheadBalcony = 150
